import PropTypes from 'prop-types';
import React from 'react';
import { ContentFeedView, DatePicker } from '..';
import Button from '../widgets/Button';
import Icon from '../widgets/Icon';
import './styles.scss';
import TimePicker from '../widgets/TimePicker';

class SpecialContentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adding: false,
      specialContent: props.specialContent,
      dateTime_from: "2017-1-1",
      dateTime_to: '2017-2-1',
      from_time: "00:00",
      to_time: "02:00",
    };
  }

  static propTypes = {
    notifSend: PropTypes.array.isRequired,
    specialContent: PropTypes.array.isRequired,
    deviceGroup: PropTypes.func.isRequired,
    onSpecialContentAdd: PropTypes.func.isRequired,
    onSpecialContentChange_from: PropTypes.func.isRequired,
    onSpecialContentChange_to: PropTypes.func.isRequired,
    onSpecialContentFeedChange: PropTypes.func.isRequired,
    onSpecialContentDelete: PropTypes.func.isRequired,
  };

  handleAddClick = () => this.setState({adding: true});
  handleCancleClick = () => this.setState({adding: false});

  handleAddSpecialContent = () => {
    let d_from = new Date(`${this.state.dateTime_from} ${this.state.from_time}`)
    let d_to = new Date(`${this.state.dateTime_to} ${this.state.to_time}`)
    let from = `${d_from.getFullYear()}-${`${d_from.getMonth()+1}`.padStart(2, '0')}-${`${d_from.getDate()}`.padStart(2, '0')} ${`${d_from.getHours()}`.padStart(2, '0')}:${`${d_from.getMinutes()}`.padStart(2, '0')}`
    let to = `${d_to.getFullYear()}-${`${d_to.getMonth()+1}`.padStart(2, '0')}-${`${d_to.getDate()}`.padStart(2, '0')} ${`${d_to.getHours()}`.padStart(2, '0')}:${`${d_to.getMinutes()}`.padStart(2, '0')}`
    let from_reg = Number(from.replace(/\s|-|:/g, ''))
    let to_reg = Number(to.replace(/\s|-|:/g, ''))

    let is_overlaping = false

    this.state.specialContent.map(
      (content) => {
        let content_d_from = new Date(`${content.dateTime_from.slice(0,10)} ${content.dateTime_from.slice(11,16)}`)
        let content_d_to = new Date(`${content.dateTime_to.slice(0,10)} ${content.dateTime_to.slice(11,16)}`)
        let content_from = `${content_d_from.getFullYear()}-${`${content_d_from.getMonth()+1}`.padStart(2, '0')}-${`${content_d_from.getDate()}`.padStart(2, '0')} ${`${content_d_from.getHours()}`.padStart(2, '0')}:${`${content_d_from.getMinutes()}`.padStart(2, '0')}`
        let content_to = `${content_d_to.getFullYear()}-${`${content_d_to.getMonth()+1}`.padStart(2, '0')}-${`${content_d_to.getDate()}`.padStart(2, '0')} ${`${content_d_to.getHours()}`.padStart(2, '0')}:${`${content_d_to.getMinutes()}`.padStart(2, '0')}`
        let content_from_reg = Number(content_from.replace(/\s|-|:/g, ''))
        let content_to_reg = Number(content_to.replace(/\s|-|:/g, ''))

        if(
          content_from_reg >= from_reg && content_from_reg < to_reg ||
          content_to_reg > from_reg && content_to_reg <= to_reg ||
          content_from_reg <= from_reg && content_to_reg >= to_reg 
        ){
          is_overlaping = true
        }
      }
    )
    
    if(is_overlaping == true){
      this.props.notifSend({
        message: "Sorry, A Special Content Exists Within This DateTime Range",
        kind: "alert",
        dismissAfter: 5000,
      })
    }else if(from_reg>to_reg){
      this.props.notifSend({
        message: "DateTime From can not be greater than DateTime To",
        kind: "alert",
        dismissAfter: 5000,
      })
    }else if(from_reg === to_reg){
      this.props.notifSend({
          message: `To DateTime ${to} can not be equal to From DateTime  ${from}`,
          kind: "alert",
          dismissAfter: 5000,
        }
      )
    }else{
      this.props.onSpecialContentAdd({dateTime_from: from, dateTime_to:to});
      this.setState({adding: false});
    }
  }

  handleAddSpecialContent_from = (date) => {
    this.setState({dateTime_from: date})
  }

  handleAddSpecialContent_to = (date) => {
    this.setState({dateTime_to: date})
  }

  handleDateSpecialContentChange_from = (entry, date, idx) => {
    let from = `${date} ${entry.dateTime_from.slice(11,16)}`
    const specialContent = [...this.state.specialContent];
    specialContent[idx].dateTime_from = from;
    this.setState({specialContent});
    this.props.onSpecialContentChange_from(specialContent[idx]);
  }

  handleDateSpecialContentChange_to = (entry, date, idx) => {
    let to = `${date} ${entry.dateTime_to.slice(11,16)}`
    const specialContent = [...this.state.specialContent];
    specialContent[idx].dateTime_to = to;
    this.setState({specialContent});
    this.props.onSpecialContentChange_to(specialContent[idx]);
  }

  handleTimeSpecialContentChange_from = (entry, time, idx) => {
    let from = `${entry.dateTime_from.slice(0,10)} ${time}`
    const specialContent = [...this.state.specialContent];
    specialContent[idx].dateTime_from = from;
    this.setState({specialContent});
    this.props.onSpecialContentChange_from(specialContent[idx]);
  }

  handleTimeSpecialContentChange_to = (entry, time, idx) => {
    let to = `${entry.dateTime_to.slice(0,10)} ${time}`
    const specialContent = [...this.state.specialContent];
    specialContent[idx].dateTime_to = to;
    this.setState({specialContent});
    this.props.onSpecialContentChange_to(specialContent[idx]);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.specialContent !== nextProps.specialContent) {
      this.setState({specialContent: nextProps.specialContent});
    }
  }

  getSpecialContentErrors(specialContents) {
    const errors = {msg: ''};

    specialContents.forEach(
      entry =>
        errors[entry.id] = (entry.dateTime_to <= entry.dateTime_from)
          ? 'Start datetime must be before end datetime.'
          : null,
    );

    return errors;
  }

  handleToggleCollapse = () => this.setState({expanded: !this.state.expanded});

  render() {
    if (!this.state.expanded) return this.renderCollapsed();
    const errors = this.getSpecialContentErrors(this.state.specialContent);

    return (
      <div className="special-content-view expanded card depth-3">
        <div className="header" onClick={this.handleToggleCollapse}>
          <h3>Content for Special Occasions:</h3>
          <Icon title="Collapse" name="minus"/>
        </div>
        <p style={{maxWidth: '100%', marginTop: 0}}>
          Here you can set up special content to play on holidays, festivals or other special
          occasions.
        </p>
        
        {this.state.specialContent.map((entry, idx) => (
          <div className="special-content-entry" key={entry.id}>
            <ContentFeedView feed={entry.content}
              deviceGroup={this.props.deviceGroup}
              profile={this.props.profile}
              onChange={this.props.onSpecialContentFeedChange}
            />

            <div className='add_datetime_overlay'>
              <div className='addFrom_datetime_overlay'>
                <span className='datetime_label2'>From:</span> <span className='datetime_label'>Date</span> <DatePicker  defaultValue={entry.dateTime_from.slice(0,10)} onChange={(date) => this.handleDateSpecialContentChange_from(entry, date, idx)}/> 
                <span className='datetime_label'>Time</span> <TimePicker onChange={(time) => this.handleTimeSpecialContentChange_from(entry, time, idx)}
                  defaultTime={entry.dateTime_from.slice(11,16)} editing={true}/>
              </div>

              <div className='addTo_datetime_overlay'>
                <span className='datetime_label2'>To:</span> <span className='datetime_label'>Date</span> <DatePicker  defaultValue={entry.dateTime_to.slice(0,10)} onChange={(date) => this.handleDateSpecialContentChange_to(entry, date, idx)}/>
                <span className='datetime_label'>Time</span> <TimePicker onChange={(time) => this.handleTimeSpecialContentChange_to(entry, time, idx)}
                  defaultTime={entry.dateTime_to.slice(11,16)} editing={true}/>
              </div>
            </div>
            
            <Icon title="Delete"
              name="trash-o"
              size="2rem"
              onClick={() => this.props.onSpecialContentDelete(entry)}
            />
          </div>
        ))}
        <div className="actions">
          {this.state.adding
            ? <div id='datetime_overlay'>
              <div className='add_datetime_overlay'>
                <div className='addFrom_datetime_overlay'>
                  <span className='datetime_label2'>From:</span> <span className='datetime_label'>Date</span> <DatePicker defaultValue={this.state.dateTime_from} onChange={this.handleAddSpecialContent_from}/> 
                  <span className='datetime_label'>Time</span> <TimePicker onChange={(time) => this.setState({from_time: time})}
                    defaultTime={this.state.from_time} editing={true}/>
                </div>

                <div className='addTo_datetime_overlay'>
                  <span className='datetime_label2'>To:</span> <span className='datetime_label'>Date</span> <DatePicker defaultValue={this.state.dateTime_to} onChange={this.handleAddSpecialContent_to}/>
                  <span className='datetime_label'>Time</span> <TimePicker onChange={(time) => this.setState({to_time: time})}
                    defaultTime={this.state.to_time} editing={true}/>
                </div>
              </div>

              <div id='btn_datetime_overlay'>
                <Button onClick={this.handleAddSpecialContent}>Save</Button>
                <Button onClick={this.handleCancleClick}>Cancel</Button>
              </div>
            </div>
            : <>
              <Button onClick={this.handleAddClick}>Add</Button>
            </>
          }
        </div>
      </div>
    );
  }

  renderCollapsed() {
    return (
      <div className="schedule-view collapsed card depth-1">
        <div className="header" onClick={this.handleToggleCollapse}>
          <h3>Content for Special Occasions</h3>
          <Icon title="Expand" name="plus"/>
        </div>
      </div>
    );
  }
}

export default SpecialContentView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/SpecialContentView/index.js